import ph_default from './placeholders/ph_default.jpg'

const Placeholders = {
    ph_default,
}


export {Placeholders}